import Cookies from 'js-cookie';

const TokenKey = 'buyerCookie';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  console.log(TokenKey);

  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
